import axios from 'axios'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { API_URL } from 'src/cms/constants/EndPoint'
import { MasterDataStore, MasterDataSyncStatusSet } from 'src/setup/redux/MasterDataOption'

const postMasterData = async () => {
  try {
    const response = await axios.get(`${API_URL}/master-data?table=${'all'}`)
    return response?.data
  } catch (error: any) {
     throw new Error(`${error?.response?.data?.message}`)
  }
}

const useGetMasterDataStore = () => {
  const dispatch = useDispatch()

  return useMutation(() => postMasterData(), {
    onMutate: () => {
      dispatch(MasterDataSyncStatusSet('syncing'))
    },
    onSuccess: (response: any) => {
      dispatch(MasterDataStore(response?.data))
      dispatch(MasterDataSyncStatusSet('idle'))
    },
    onError: (error: Error) => {
      dispatch(MasterDataSyncStatusSet('failed'))
      toast.error(`Error: ${error?.message ?? 'An error occurred'}`)
    },
  })
}

export default useGetMasterDataStore
